export enum FlightCardTypes {
  SUMMARY = "flight",
  OTP = "otp",
  SLOT_ADHERENCE = "slotAdherence",
  RUNWAY_DELAYS = "runwayDelays",
  TURNAROUND_SUFFICIENCY = "turnAround",
  REGULATED_FLIGHT = "regulatedFlight",
  ADDITIONAL_DELAY = "additionalDelay",
}
export enum KpiTypes {
  OTP = "onTimePerformance",
  SLOT_ADHERENCE = "slotAdherence",
  TURNAROUND_SUFFICIENCY = "turnaroundSufficiency",
}
